module.exports = __webpack_public_path__ + "img/cat-eyes.96ed65bd.png";